import {
  LiquidationSignalMode,
  MaRelativeMode,
  MaSlopeNormalization,
  MaTrendDirection,
  RelativePosition,
  RsiMode,
  SignalType,
  ValueMode,
  ValueReactionDirection,
  ValueReactionEvent,
  ValueReactionScope
} from '@shared/types';
import type {
  LiquidationSignalParams,
  MaRelativeSignalParams,
  RsiSignalParams,
  ValueReactionSignalParams,
  ValueRelativeSignalParams
} from '@server/data-feed/schemas/input.schema';

type MaTrendSignalParams = Extract<
  MaRelativeSignalParams,
  { mode: typeof MaRelativeMode.TREND }
>;
type MaReversalSignalParams = Extract<
  MaRelativeSignalParams,
  { mode: typeof MaRelativeMode.REVERSAL }
>;
type MaToMaSignalParams = Extract<
  MaRelativeSignalParams,
  { mode: typeof MaRelativeMode.MA_TO_MA }
>;
type RsiLevelSignalParams = Extract<
  RsiSignalParams,
  { mode: typeof RsiMode.LEVEL }
>;

export const strategySignalOptions = Object.values(SignalType);

export const defaultValueRelativeParams: ValueRelativeSignalParams = {
  mode: ValueMode.RELATIVE,
  position: RelativePosition.BELOW
};

export const defaultValueReactionParams: ValueReactionSignalParams = {
  mode: ValueMode.REACTION,
  scope: ValueReactionScope.LATEST,
  direction: ValueReactionDirection.BEARISH,
  event: ValueReactionEvent.RETEST,
  touchTolerancePct: 0.1,
  breakMinDistancePct: 0,
  confirmationCandles: 3,
  preBreakCandles: 1,
  keepSignalState: true,
  maxHistoricalLevels: 3,
  cooldownBarsPerLevel: 0
};

export const defaultMaRelativeParams: MaTrendSignalParams = {
  mode: MaRelativeMode.TREND,
  period: 200,
  direction: MaTrendDirection.UP,
  lookbackBars: 5
};

export const defaultMaReversalParams: MaReversalSignalParams = {
  mode: MaRelativeMode.REVERSAL,
  period: 200,
  direction: MaTrendDirection.UP,
  minAngleUpDeg: 5,
  minAngleDownDeg: 5,
  normalization: MaSlopeNormalization.PCT,
  atrPeriod: 14,
  keepSignalState: true
};

export const defaultMaToMaParams: MaToMaSignalParams = {
  mode: MaRelativeMode.MA_TO_MA,
  period: 50,
  referencePeriod: 200,
  position: RelativePosition.BELOW
};

export const defaultRsiParams: RsiLevelSignalParams = {
  mode: RsiMode.LEVEL,
  position: RelativePosition.BELOW,
  level: 50,
  confirmationCandles: 1
};

export const defaultLiquidationParams: LiquidationSignalParams = {
  mode: LiquidationSignalMode.BEARISH,
  keepSignalState: true
};
